module.exports = __webpack_public_path__ + "static/media/overdrive_right.c0592100.png";